import React, { useState } from 'react';
import { Tag } from 'primereact/tag';

const TagList = (props) => {
    const [hovered, setHovered] = useState(false);
    const [hoveredLongName, setHoveredLongName] = useState(false);
    const[hoveredTagName, setHoveredTagName] = useState("");


    const handleHover = () => setHovered(true);
    const handleLeave = () => setHovered(false);

    const handleHoverLongName = (tagName) => {
        setHoveredLongName(true);
        setHoveredTagName(tagName);
    }
    const handleLeaveLongName = () => {
        setHoveredLongName(false);
        setHoveredTagName("");
    }

    const firstTwoTags = props.tags.slice(0, 2);

    return (
        <div style={{ position: 'relative' }}>
            {/* Render the first two tags */}
            {firstTwoTags.map((tag) => (
                <>
                    <Tag
                        key={tag.id}
                        style={{ backgroundColor: '#487c84', color: 'white', marginRight: '4px', marginTop: '3px' }}
                        value={tag.name.length > 15 ? `${tag.name.substring(0, 12)}...` : tag.name}
                        onMouseEnter={() => handleHoverLongName(tag.name)}
                        onMouseLeave={handleLeaveLongName}
                        rounded
                    >
                    </Tag>

                </>
            ))}
            {hoveredLongName && hoveredTagName.length>15 && (
                <div style={{position: 'relative',zIndex: 1000}}>
                    <div
                        style={{
                            position: 'absolute',
                            backgroundColor: 'white',
                            border: '1px solid #ccc',
                            padding: '8px',
                            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                            borderRadius: '4px',
                            marginTop: '5px',
                            zIndex: 1000,
                        }}
                    >
                        <div>{hoveredTagName}</div>
                    </div>
                </div>
            )}


            {props.tags.length > 2 && (
                <>
                    <Tag
                        style={{
                            backgroundColor: '#487c84',
                            color: 'white',
                            marginRight: '4px',
                            marginTop: '3px',
                            cursor: 'pointer',
                        }}
                        value="..."
                        onMouseEnter={handleHover}
                        onMouseLeave={handleLeave}
                        rounded
                    />
                    {hovered && (
                        <div style={{position: 'relative',zIndex: 1000}}>
                            <div
                                style={{
                                    position: 'absolute',
                                    backgroundColor: 'white',
                                    border: '1px solid #ccc',
                                    padding: '8px',
                                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                    borderRadius: '4px',
                                    marginTop: '5px',
                                    zIndex: 1000,
                                }}
                            >
                                {props.tags.map((tag) => (
                                    <div key={tag.id}>{tag.name}</div>
                                ))}
                            </div>
                        </div>
                    )}

                </>
            )}
        </div>
    );
};

export default TagList;
